import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ImpactPerformance extends Vue {
  private isGrade: boolean = false;
  private isMathExp: boolean = false;
  private isWake: boolean = false;
  private isEthinic: boolean = false;
  private isShowData: boolean = false;

  public showGradeDetail() {
    this.isGrade = true;
    this.isMathExp = false;
    this.isWake = false;
    this.isEthinic = false;
    this.isShowData = false;
  }
  public hideGradeDetail() {
    this.isGrade = false;
    this.isMathExp = false;
    this.isWake = false;
    this.isEthinic = false;
    this.isShowData = false;
  }
  public showMathDetail() {
    this.isMathExp = true;
    this.isGrade = false;
    this.isWake = false;
    this.isEthinic = false;
    this.isShowData = false;
  }
  public showCountryDetail() {
    this.isWake = true;
    this.isMathExp = false;
    this.isGrade = false;
    this.isEthinic = false;
    this.isShowData = false;
  }
  public showEthinicDetail() {
    this.isEthinic = true;
    this.isWake = false;
    this.isMathExp = false;
    this.isGrade = false;
    this.isShowData = false;
  }
  public showDataDetail() {
    this.isShowData = true;
    this.isGrade = false;
    this.isMathExp = false;
    this.isWake = false;
    this.isEthinic = false;
  }
}
